import axios from 'axios'
import { InspectionAttachmentSummary, InspectionAttachmentScope, inspectionAttachmentResource } from '@numeo/types-core'
import { getApiBaseUrlWithoutV1 } from '../setup/SetupAxios'

export const inspectionMultipartBody = (data: object, files: File[]): object | FormData => {
    if (!files.length) return data
    const body = new FormData()
    body.append('data', JSON.stringify(data))
    for (const file of files) body.append('files', file)
    return body
}

const attachmentPath = (scope: InspectionAttachmentScope, inspectionId: string) =>
    `/${scope}/inspections/${inspectionAttachmentResource(scope)}/${encodeURIComponent(inspectionId)}/attachments/v1`

export const uploadInspectionAttachments = async (
    scope: InspectionAttachmentScope,
    inspectionId: string,
    files: File[]
): Promise<InspectionAttachmentSummary[]> => {
    const body = new FormData()
    for (const file of files) body.append('files', file)
    const { data } = await axios.post<{ data: InspectionAttachmentSummary[] }>(attachmentPath(scope, inspectionId), body, { baseURL: getApiBaseUrlWithoutV1() })
    return data.data
}

export const removeInspectionAttachment = async (
    scope: InspectionAttachmentScope,
    inspectionId: string,
    attachmentId: string
): Promise<InspectionAttachmentSummary[]> => {
    const { data } = await axios.delete<{ data: InspectionAttachmentSummary[] }>(`${attachmentPath(scope, inspectionId)}/${encodeURIComponent(attachmentId)}`, {
        baseURL: getApiBaseUrlWithoutV1(),
    })
    return data.data
}

export const getInspectionAttachmentPreview = async (
    scope: InspectionAttachmentScope,
    inspectionId: string,
    attachmentId: string,
    signal?: AbortSignal
): Promise<Blob> => {
    const { data } = await axios.get<Blob>(`${attachmentPath(scope, inspectionId)}/${encodeURIComponent(attachmentId)}/content`, {
        baseURL: getApiBaseUrlWithoutV1(),
        responseType: 'blob',
        ...(signal ? { signal } : {}),
    })
    return data
}
